import { DEFAULT_LOCALE } from '@mc/constants'
import { getCurrentLocale } from '@mc/i18n'
import deepMapKeys from 'deep-map-keys'
import { camelCase } from 'lodash'

export const getLocalizedText = (locales: Record<string, string>) => {
  const camelCaseLocales: Record<string, string> = deepMapKeys(
    locales,
    camelCase,
  )
  const currentLocale = camelCase(getCurrentLocale())
  return currentLocale in camelCaseLocales
    ? camelCaseLocales[currentLocale]
    : camelCaseLocales[camelCase(DEFAULT_LOCALE)]
}
